import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($setup.charger ? 'charging' : 'start-charging')
  }, [
    _withDirectives(_createVNode($setup["LoadingLayout"], {
      "loading-text": _ctx.$t('chargingPage.loadingText')
    }, null, 8, ["loading-text"]), [
      [_vShow, !$setup.successfullLoaded]
    ]),
    _withDirectives(_createVNode($setup["ConnectorLayout"], {
      "start-call-is-loading": $setup.startCallIsLoading,
      onConnectorchanged: $setup.connectorChanged
    }, null, 8, ["start-call-is-loading"]), [
      [_vShow, $setup.successfullLoaded && !$setup.charger]
    ]),
    ($setup.charger)
      ? (_openBlock(), _createBlock($setup["ChargingLayout"], {
          key: 0,
          "selected-charger": $setup.charger,
          "charging-started-at": $setup.chargingStartedAt
        }, null, 8, ["selected-charger", "charging-started-at"]))
      : _createCommentVNode("", true),
    ($setup.isFeedbackModalActive)
      ? (_openBlock(), _createBlock($setup["FeedbackModal"], {
          key: 1,
          "main-title": $setup.errorModalTitles.main,
          "sub-title": $setup.errorModalTitles.sub,
          success: false,
          onConfirm: $setup.handleFeedbackModalOkClick
        }, null, 8, ["main-title", "sub-title"]))
      : _createCommentVNode("", true)
  ], 2))
}